import React, { Component } from 'react'

import s from './Checkbox.scss'
import cn from 'classnames'
import imgTapThis from 'static/images/hand-writing/tap-this-bottom-right.svg'

export default class Checkbox extends Component {
  onChange = event => {
    const { input, onChangeAlt } = this.props
    if (onChangeAlt) {
      onChangeAlt(event)
    } else {
      input.onChange(!input.value)
    }
  }
  render() {
    const {
      className,
      showTip,
      input,
      style,
      meta: { touched, error },
    } = this.props
    const id = Math.random()
      .toString(36)
      .substring(7)
    const isInvalid = touched && error
    const classes = cn(
      s.checkbox,
      { [s.active]: input.value },
      { [s.invalid]: isInvalid },
      className
    )

    return (
      <div className={classes} style={style}>
        {showTip && <img className={s.tapThis} src={imgTapThis} />}
        <label htmlFor={id} />
        <input id={id} type="checkbox" {...input} onChange={this.onChange} onBlur={() => {}} />
      </div>
    )
  }
}

//            value={ input.value }
//            onChange={ input.onChange }
//            name={ input.name }



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Input/Checkbox/Checkbox.jsx